module.exports = __webpack_public_path__ + "media/banners/dx_boost-f5c8c06f.png";